import React from "react";

import type { Stripe, StripeElementLocale } from "@stripe/stripe-js";
import { useIntl } from "react-intl";

import {
  StripeInstanceContextType,
  StripeInstanceProviderProps,
} from "./stripe.types";

const StripeContext = React.createContext<StripeInstanceContextType | null>(
  null,
);

const StripeContextProvider = ({
  children,
  stripeKey,
  options,
}: StripeInstanceProviderProps) => {
  const [stripeInstance, setStripeInstance] = React.useState<Stripe | null>(
    null,
  );

  const intl = useIntl();

  React.useEffect(() => {
    if (!stripeKey) {
      return;
    }

    const initStripe = async () => {
      const { loadStripe } = await import("@stripe/stripe-js");
      const stripe = await loadStripe(stripeKey, {
        locale: intl.locale as StripeElementLocale,
        ...options,
      });

      setStripeInstance(stripe);
    };

    initStripe();
  }, [stripeKey, intl.locale, options]);

  return (
    <StripeContext.Provider value={{ stripeInstance }}>
      {children}
    </StripeContext.Provider>
  );
};

export { StripeContextProvider, StripeContext };
